import MaterialTable from '@material-table/core';
import classnames from 'classnames';
import { ThemeProvider } from '@material-ui/styles';
import { tableIcons } from 'common/util/materialTable/materialTableIcons';
import { localization } from 'common/util/materialTable/localization';
import { viewDetails, viewDetailsColumn, DetailPanel, tasksOptions, tasksTheme } from './BinderTaskV2';
import styles from './BinderTaskV2.scss';
import {datesSort} from 'complionUtil/materialTable/sorting';


export const IncompleteTasks = ({allPending, institutionId, binderId}) => {
    const incompleteTasksColumn = [
        {
            title: 'Recipient',
            field: 'recipient',
            cellStyle: {
                width: '30%',
                minWidth: '30%',
            },
            render: (task) =>  {
                return(
                    <div data-cy="IncompleteTasks">
                        <p data-cy="IncompleteTasks-recipient">{task.recipient}</p>
                        <div>
                            <DetailPanel 
                                totalTasks={task.totalTasks} 
                                detailedRecipients={task.detailedRecipients} />
                        </div>
                    </div>
                );
            }
        },
        {
            title: 'Type',
            field: 'documentType',
            cellStyle: {
                fontSize : '14px',
                minWidth: '20%',
            }
        },
        {
            title: 'Sent Date',
            field: 'sentDate',
            headerStyle: {
                textAlign: 'center'
            },
            cellStyle: {
                textAlign: 'center',
                paddingLeft: '0px',
                fontSize : '14px',
            },
            customSort: (row1, row2) => datesSort(row1.sentDate, row2.sentDate)
        },
        {
            title: 'Priority',
            field: 'priority',
            headerStyle: {
                textAlign: 'center'
            },
            cellStyle: {
                textAlign: 'center',
                paddingLeft: '0px',
                paddingTop: '7px !important',
                fontSize : '14px',
            },
            render: (task) => {
                const label = `Sent ${task.priority > 13 ? '14+' : task.priority} Day${task.priority > 1 ? 's' : ''} Ago`;
                return(
                    <div data-cy="IncompleteTasks-label" className={
                        classnames(
                            styles.priority,
                            {
                                [styles.error]: task.priority >= 14,
                                [styles.warning]: task.priority > 6 && task.priority <14,
                            }
                        )
                    }>
                        {label}
                    </div>
                );
            }
        },
        viewDetailsColumn(institutionId, binderId),
    ];

    return(
        <ThemeProvider theme={tasksTheme}>
            <div data-cy="IncompleteTasks-return">
                <MaterialTable 
                    options={tasksOptions}
                    icons={tableIcons}
                    data={allPending}
                    localization={localization}
                    onRowClick={(event, data) => viewDetails(event, data, institutionId, binderId)}
                    columns={incompleteTasksColumn}
                    actions={[
                        task => (
                            {hidden : 'true'}
                        )
                    ]}
                    components={{
                        Action: binderRow => <div><i className={styles.error_icon} />{binderRow.priority}</div>
                    }}
                />
            </div>
        </ThemeProvider>
    );
};
